import { selectors as core } from '../../core';
import * as types from '../constants/action-types';
export const isLoggingIn = (state) => core.isLoading(state, types.LOGIN.NAME);
export const getLoginError = (state) => core.getError(state, types.LOGIN.NAME);
